(function() {
	'use strict';

	angular.module('investPlusApp').controller('InvestPlusController',
			InvestPlusController);

	InvestPlusController.$inject = [ '$scope', '$window', 'InvestPlusService',
			'CommonService', 'FileNetService', '$http', '$uibModal', '$log',
			'$base64', 'Upload', 'authExpiredInterceptor', 'AlertService',
			'$stateParams', '$state', 'CONST_COMMON', '$filter' ];

	function InvestPlusController($scope, $window, InvestPlusService,
			CommonService, FileNetService, $http, $uibModal, $log, $base64,
			Upload, authExpiredInterceptor, AlertService, $stateParams, $state,
			CONST_COMMON, $filter) {
		var investPlusCtr = this;
		$scope.loading = false;
		var self = $scope;
		var param = $stateParams;
		investPlusCtr.listFund = [];
		investPlusCtr.listInvestment = [];
		investPlusCtr.invest = {};
		investPlusCtr.invest.agentCode = {};
		investPlusCtr.validPolicy = false;
		investPlusCtr.files = [];
		investPlusCtr.filesPersonal = [];
		investPlusCtr.archiveDataIdsDelete = [];
		investPlusCtr.listNational = [];
		investPlusCtr.listCountry = [];
		investPlusCtr.listDistrict = [];
		investPlusCtr.listWard = [];
		investPlusCtr.datePickerOpenStatus = {};
		investPlusCtr.datePickerOpenStatus.bankReceiptDate = false;
		investPlusCtr.datePickerOpenStatus.receiptDate = false;
		investPlusCtr.datePickerOpenStatus.receiptDueDate = false;
		investPlusCtr.thirdPartyStatus ='';
		self.HIT ='HIT'
		self.PDK = '1';
		self.HTTD = '2';
		self.HTTU = '3';
		self.KK = '4';
		self.PG = '7';
		self.showDescription = false;
		self.listReasonCancel = {};
		self.errorMess = {};
		self.dateOptions = {
			maxDate: new Date()
		};
		self.firstLoad = 1;
		self.oneDoor = false;

		investPlusCtr.invest = {};
		investPlusCtr.isVR1 = false;

		investPlusCtr.sendSuccessful = false;

		self.totalAmountThirdParty = 0;
		self.totalAmountThirdPartyTemp = 0;
		self.amountLT300m = true;
		self.checkSignature = false;
		self.checkIsThirdParty = false;
		self.msgThirdPartyInFiserv = '';
		self.invalidInvestmentValue = false;

		investPlusCtr.send = function () {
			var haveInvestmentValue = false;
			var haveError = false;
			var totalPercent = 0;
			var totalValue = 0;
			var j = 0;

			investPlusCtr.invest.listInvestmentPlus = [];
			if(self.checkIsThirdParty){
				self
					.addAlert(
						'Vui lòng nhấn nút kiểm tra trước khi thực hiện tiếp.',
						'warning');
				haveError = true;
			}
			if(self.msgThirdPartyInFiserv.length > 0){
				self
					.addAlert(
						self.msgThirdPartyInFiserv,
						'error');
				haveError = true;
			}
			if (!self.checkSignature) {
				self
					.addAlert(
						'Nhân viên kiểm tra chữ ký khách hàng trước khi thực hiện Gửi duyệt.',
						'warning');
				self.checkSignature = true;
				haveError = true;
			}

			if (investPlusCtr.invest.investmentValue > investPlusCtr.invest.excessFee) {
				if (parseInt(investPlusCtr.invest.totalAmount) < (parseInt(investPlusCtr.invest.investmentValue) - parseInt(investPlusCtr.invest.excessFee))) {
					console
						.log(
							"FEE",
							(parseInt(investPlusCtr.invest.investmentValue) - parseInt(investPlusCtr.invest.excessFee)));
					console.log(
						"(parseInt(investPlusCtr.invest.investmentValue)",
						parseInt(investPlusCtr.invest.investmentValue));
					console.log("parseInt(investPlusCtr.invest.excessFee))",
						parseInt(investPlusCtr.invest.excessFee));

					self
						.addAlert(
							'Tổng tiền phải lớn hơn hoặc bằng số tiền đầu tư thêm.',
							'warning');
					haveError = true;
				}
			}

			if (investPlusCtr.invest.investmentType == 'PERCENT') {
				for (var i = 0; i < investPlusCtr.listInvestmentPlus.length; i++) {
					var fundTemp = investPlusCtr.listInvestmentPlus[i];
					if (fundTemp.percent != null) {
						if (parseFloat(fundTemp.percent) % 5 != 0) {
							// investPlusCtr.listInvestmentPlus[index].percent = null;
							self.addAlert(
								'Tỷ lệ đầu tư phải là bội số của 5.',
								'warning');
							haveError = true;
							return;
						}
						totalPercent += fundTemp.percent;
						fundTemp.investmentName = investPlusCtr.listFund[i].name;
						fundTemp.investmentCode = investPlusCtr.listFund[i].code;
						investPlusCtr.invest.listInvestmentPlus[j] = fundTemp;
						j++;
						haveInvestmentValue = true;
					}
				}
				if (haveInvestmentValue) {
					if (totalPercent != 100) {
						self
							.addAlert('Tổng tỷ lệ đầu tư phải bằng 100%.',
								'warning');
						haveError = true;
					}
				}
			} else if (investPlusCtr.invest.investmentType == 'MONEY') {
				for (var i = 0; i < investPlusCtr.listInvestmentPlus.length; i++) {
					var fundTemp = investPlusCtr.listInvestmentPlus[i];
					if (fundTemp.value != null) {
						totalValue = parseFloat(totalValue) + parseFloat(fundTemp.value);
						fundTemp.investmentName = investPlusCtr.listFund[i].name;
						fundTemp.investmentCode = investPlusCtr.listFund[i].code;
						investPlusCtr.invest.listInvestmentPlus[j] = fundTemp;
						j++;
						haveInvestmentValue = true;
					}
				}
				if (haveInvestmentValue) {
					if (parseFloat(totalValue) < parseFloat(investPlusCtr.invest.investmentValue)) {
						self.addAlert(
							'Tổng giá trị đầu tư nhỏ hơn số tiền đầu tư.',
							'warning');
						haveError = true;
					} else if (parseFloat(totalValue) > parseFloat(investPlusCtr.invest.investmentValue)) {
						self.addAlert(
							'Tổng giá trị đầu tư vượt quá số tiền đầu tư.',
							'warning');
						haveError = true;
					}
				}
			}
			investPlusCtr.invest.officeCode = self.$parent.appCtrl.currentOffice.officeCode;
			if (!haveInvestmentValue) {
				self
					.addAlert(
						'Vui lòng nhập giá trị.',
						'danger');
				haveError = true;
			}
			if (!haveError) {
				var data = [];
				self.loading = true;
				if (investPlusCtr.files) {
					for (var int = 0; int < investPlusCtr.files.length; int++) {
						var array_element = investPlusCtr.files[int];
						data['fileInvestPlus' + int] = array_element;

					}
				}

				if (investPlusCtr.filesPersonal) {
					for (var int = 0; int < investPlusCtr.filesPersonal.length; int++) {
						var array_element = investPlusCtr.filesPersonal[int];
						data['fileThirdParty' + int] = array_element;

					}
				}

				data['investPlus'] = new Blob([JSON
					.stringify(investPlusCtr.invest)], {
					type: "application/json"
				});

				Upload
					.upload(
						{
							url: GLOBAL_URL
								+ 'api/ga/investment-plus/do-save?access_token='
								+ authExpiredInterceptor.getToken(),
							data: data
						}).then(function (resp) {
					self.isDisable = true;
					investPlusCtr.sendSuccessful = true;
					self.loading = false;
				}, function (resp) {
					self.loading = false;
				}, function (evt) {

				});
			}
		};

		investPlusCtr.checkSignature = function () {
			if (investPlusCtr.invest.policy.policyNum == undefined
				|| investPlusCtr.invest.policy.policyNum == null)
				return false;
			$scope.loading = true;
			self.checkSignature = true;
			FileNetService
				.query(
					{
						method: 'get-list-poldoc',
						polNum: investPlusCtr.invest.policy.policyNum
					},
					function (result) {
						if (result.length > 0) {
							$scope.loading = false;
							investPlusCtr.animationsEnabled = true;
							var modalInstance =
								// show dialog
								$uibModal
									.open({
										animation: investPlusCtr.animationsEnabled,
										templateUrl: GLOBAL_URL
											+ 'partial?uri=ga/signature/signature-dialog',
										controller: 'SignatureDialogController as signatureDlgCtrl',
										size: 'lg',
										resolve: {
											items: function () {
												return result;// tranfer
												// data
												// for
												// dialog
											}
										}
									});
							modalInstance.result.then(function (result) {
								$scope.loading = false;
							}, function (error) {
								$scope.loading = false;
							});
						} else {
							$scope.loading = false;
							$scope
								.addAlert(
									'File chữ ký HD ['
									+ investPlusCtr.invest.policy.policyNum
									+ '] không tồn tại.Vui lòng kiểm tra lại',
									'warning');
						}
					}, function (error) {
						$scope.loading = false;
					});
		};

		investPlusCtr.findPolicy = function () {
			$scope.clearMessage();
			$scope.loading = true;
			if (investPlusCtr.invest.policy == undefined
				|| investPlusCtr.invest.policy.policyNum == null
				|| investPlusCtr.invest.policy.policyNum == undefined) {
				self.addAlert('Vui lòng nhập số hợp đồng.', 'warning');
				$scope.loading = false;
			} else {
				InvestPlusService.get({
					uri: 'getByPolicynum',
					policyNum: investPlusCtr.invest.policy.policyNum
				}, function (result) {
					$scope.loading = false;
					investPlusCtr.invest = result;
					if (self.firstLoad == 1) {
						if (result.messages != null
							&& result.messages.length > 0) {
							self.investPlusForm.sohd.$setValidity(
								'errorMessage', false);
							self.errorMess = result.messages[0].message;
						} else {
							self.investPlusForm.sohd.$setValidity(
								'errorMessage', true);
							if (investPlusCtr.invest.policy.statusCode == 'IF') {
								investPlusCtr.validPolicy = true;
							}
						}
						self.firstLoad = 2;
					} else {
						self.investPlusForm.sohd.$setValidity('errorMessage',
							true);
						if (result.messages != null
							&& result.messages.length > 0) {
							investPlusCtr.validPolicy = false;
						} else {
							if (investPlusCtr.invest.policy.statusCode == 'IF') {
								investPlusCtr.validPolicy = true;
							}
						}
					}
					// if(investPlusCtr.invest.contractCode)
					// investPlusCtr.invest.excessFee = investPlusCtr.invest.lps
					// + investPlusCtr.invest.lpu;

				}, function (result) {
					$scope.loading = false;
				}).$promise
					.then(function (result) {
						if (investPlusCtr.validPolicy) {
							InvestPlusService
								.getList(
									{
										uri: 'get-list-fund',
										contractCode: investPlusCtr.invest.policy.contractCode
									},
									function (result) {
										$scope.loading = false;
										if (investPlusCtr.invest.policy.contractCode == 'VR1'
											|| investPlusCtr.invest.policy.contractCode == 'VS1') {
											investPlusCtr.listFund = $filter(
												'filter')(
												result, 'VFD1');
											investPlusCtr.listInvestmentPlus = $filter(
												'filter')(
												result, 'VFD1');
											investPlusCtr.isVR1 = true;
										} else {
											if (investPlusCtr.invest.policy.contractCode == 'UR2'
												|| investPlusCtr.invest.policy.contractCode == 'UR4'
												|| investPlusCtr.invest.policy.contractCode == 'UR5') {
												investPlusCtr.listFund = $filter(
													'filter')(result,
													'1');
												investPlusCtr.listInvestmentPlus = $filter(
													'filter')(result,
													'1');
											} else if (investPlusCtr.invest.policy.contractCode == 'UR6') {
												investPlusCtr.listFund = $filter(
													'filter')(result,
													'2');
												investPlusCtr.listInvestmentPlus = $filter(
													'filter')(result,
													'2');
											} else {
												investPlusCtr.listFund = result;
												investPlusCtr.listInvestmentPlus = result;
											}
											investPlusCtr.isVR1 = false;
											investPlusCtr.listInvestmentPlus[0].percent = null;
											investPlusCtr.listInvestmentPlus[0].value = null;
										}
										investPlusCtr.invest.investmentType = 'PERCENT';
										investPlusCtr
											.getNationality();
										investPlusCtr.invest.mobileCode = '84';
										investPlusCtr.invest.homePhoneCode = '84';
										CommonService
											.query(
												{
													masterurl: 'receipt-types'
												},
												function (
													result) {
													investPlusCtr.listVeKhoan = result;
													investPlusCtr.invest.receiptTypeCode = "4";
												});
										CommonService
											.query(
												{
													masterurl: 'receipt-subtypes'
												},
												function (
													result) {
													investPlusCtr.listDesc = result;
													investPlusCtr.invest.receiptDescription = "3";
												});
										investPlusCtr.invest.transferType = "CASH";
										investPlusCtr
											.changeTransferType();
									})
						}
					});
			}
		};

		$scope.$watch('investPlusCtr.file', function () {
			investPlusCtr.chooseUploadFiles(investPlusCtr.file);
		});

		$scope
			.$watch(
				'investPlusCtr.filePersonal',
				function () {
					investPlusCtr
						.chooseUploadFilesPersonal(investPlusCtr.filePersonal);
				});

		investPlusCtr.chooseUploadFiles = function (file) {
			if (file) {
				$scope.clearMessage();
				var obj = {
					'file': file,
					'archiveDataId': 0
				}
				if (investPlusCtr.files.length > 1)
					self.addAlert('Tối đa chỉ được đính kèm 1 file.', 'danger');
				else
					investPlusCtr.files.push(obj);
				investPlusCtr.file = null;
			}
		};

		investPlusCtr.chooseUploadFilesPersonal = function (file) {
			if (file) {
				$scope.clearMessage();
				var obj = {
					'file': file,
					'archiveDataId': 0
				}
				if (investPlusCtr.filesPersonal.length > 1)
					self.addAlert('Tối đa chỉ được đính kèm 1 file.', 'danger');
				else
					investPlusCtr.filesPersonal.push(obj);
				investPlusCtr.filePersonal = null;
			}
		};

		investPlusCtr.searchAgent = function (type) {
			var code = investPlusCtr.invest.agentCode;
			if (code == undefined || code == null || code == '') {
				investPlusCtr.invest.agentName = '';
				return;
			}
			if (code != undefined || code != '') {
				var numCode = Number(code);
				if (numCode < 10000000)
					numCode += 60000000;
				investPlusCtr.invest.agentCode = numCode.toString();
			}
			$scope.loading = true;
			InvestPlusService.get({
				uri: 'get-agent',
				agentCode: investPlusCtr.invest.agentCode
			}, function (result) {
				$scope.loading = false;
				investPlusCtr.invest.agentName = result.agentName;
			}, function (e) {
				$scope.loading = false;
			});
		};

		investPlusCtr.getNationality = function () {
			$scope.loading = true;
			InvestPlusService.query({
				uri: 'getNationality'
			}, function (result) {
				$scope.loading = false;
				investPlusCtr.listNational = result;
				investPlusCtr.invest.national = 'VN';
			}).$promise.then(function (result) {
				investPlusCtr.getProvince();
			});
		};

		investPlusCtr.getPhoneCode = function () {
			$scope.loading = true;
			InvestPlusService.query({
				uri: 'getPhoneCode'
			}, function (result) {
				$scope.loading = false;
				investPlusCtr.listPhoneCode = result;
			});
		};

		investPlusCtr.getProvince = function () {
			$scope.loading = true;
			InvestPlusService.getList({
				uri: 'getProvinceList'
			}, function (result) {
				$scope.loading = false;
				investPlusCtr.listCountry = result;
			});
		};

		investPlusCtr.getDistrict = function (provinceCode) {
			$scope.loading = true;
			if (provinceCode === undefined || provinceCode === null) {
				provinceCode = '';
			}
			InvestPlusService.getList({
				uri: 'getDistrictList',
				provinceCode: provinceCode
			}, function (result) {
				$scope.loading = false;
				if (result != null) {
					investPlusCtr.listDistrict = result
				}
			});
		};

		investPlusCtr.getWard = function (districtCode) {
			$scope.loading = true;
			if (districtCode === undefined || districtCode === null) {
				districtCode = '';
			}
			InvestPlusService.getList({
				uri: 'getWardList',
				districtCode: districtCode
			}, function (result) {
				$scope.loading = false;
				if (result != null) {
					investPlusCtr.listWard = result;
				}
			});
		};

		investPlusCtr.openCalendar = function (date) {
			$scope.clearMessage();
			investPlusCtr.datePickerOpenStatus[date] = true;
		};

		investPlusCtr.changePercent = function (index) {
			if (investPlusCtr.invest.investmentType == 'PERCENT') {

				if (index != null && index != undefined) {
					var percentTemp = investPlusCtr.listInvestmentPlus[index];
					if (percentTemp.percent != null) {
						if (parseFloat(percentTemp.percent) % 5 != 0) {
							// investPlusCtr.listInvestmentPlus[index].percent = null;
							self.addAlert(
								'Tỷ lệ đầu tư phải là bội số của 5.',
								'warning');
						} else {
							$scope.clearMessage();
						}
					}
				}
			}
			var totalPercent = 0;
			investPlusCtr.invest.totalValue = 0;
			var j = 0;
			for (var i = 0; i < investPlusCtr.listInvestmentPlus.length; i++) {
				var percentTemp = investPlusCtr.listInvestmentPlus[i];
				if (percentTemp.percent != null) {
					totalPercent += percentTemp.percent;
					investPlusCtr.listInvestment[j] = percentTemp;
					if (investPlusCtr.invest.investmentValue != undefined
						&& investPlusCtr.invest.investmentValue != ''
						&& parseFloat(investPlusCtr.invest.investmentValue) >= 0) {
						investPlusCtr.listInvestmentPlus[i].value = (percentTemp.percent * (parseInt(investPlusCtr.invest.investmentValue))) / 100;
						if (investPlusCtr.invest.policy.contractCode != 'VR1' && investPlusCtr.invest.policy.contractCode != 'VS1') {
							if (parseFloat(investPlusCtr.listInvestmentPlus[i].value) > parseFloat(investPlusCtr.invest.maxTopup * investPlusCtr.invest.api)) {
								self.addAlert(
									'Phí đầu tư thêm vượt quá qui định.',
									'warning');
							}
						}
						investPlusCtr.invest.totalValue += investPlusCtr.listInvestmentPlus[i].value;
					}
					j++;
					if (investPlusCtr.invest.policy.contractCode === 'VR1') {
						if (parseFloat(investPlusCtr.listInvestmentPlus[i].value) < 1000000) {
							self.addAlert(
								'Phí đầu tư thêm không đạt phí tối thiểu.',
								'warning');
						}
					}
				} else {
					investPlusCtr.listInvestmentPlus[i].value = null;
				}
			}
			investPlusCtr.invest.totalPercent = totalPercent;
		};

		investPlusCtr.changeValue = function (index) {
			self.clearMessage();
			var totalValue = 0;
			// investPlusCtr.invest.totalPercent = 0;
			var j = 0;
			for (var i = 0; i < investPlusCtr.listInvestmentPlus.length; i++) {
				var valueTemp = investPlusCtr.listInvestmentPlus[i];

				if (valueTemp.value != null && valueTemp.value !== '') {

					// investPlusCtr.listInvestmentPlus[j].percent = null;
					totalValue = parseFloat(totalValue)
						+ parseFloat(valueTemp.value);
					investPlusCtr.listInvestment[j] = valueTemp;
					if (parseFloat(valueTemp.value) < investPlusCtr.invest.minTopup) {
						self.addAlert(
							'Phí đầu tư thêm không đạt phí tối thiểu.',
							'warning');
						return;
					} else {
						self.clearMessage();
					}
					if (investPlusCtr.invest.policy.contractCode != 'VR1' && investPlusCtr.invest.policy.contractCode != 'VS1') {
						if (parseFloat(valueTemp.value) > parseFloat(investPlusCtr.invest.maxTopup * investPlusCtr.invest.api)) {
							self.addAlert(
								'Phí đầu tư thêm vượt quá qui định.',
								'warning');
							return;
						} else {
							self.clearMessage();
						}
					}
					// } else {
					// 	investPlusCtr.listInvestmentPlus[i].value = null;
				}
				j++;

				if (investPlusCtr.invest.policy.contractCode === 'VR1') {
					if (parseFloat(valueTemp.value) < 1000000) {
						self.addAlert(
							'Phí đầu tư thêm không đạt phí tối thiểu.',
							'warning');
						return;
					}
				}
			}
			investPlusCtr.invest.totalPercent = null;
			investPlusCtr.invest.totalValue = totalValue;
		};

		$scope
			.$watch(
				'investPlusCtr.invest.investmentValue',
				function () {
					$scope.clearMessage();
					if (investPlusCtr.invest.investmentValue != undefined
						&& investPlusCtr.invest.investmentValue != ''
						&& parseFloat(investPlusCtr.invest.investmentValue) > 0) {
						if (investPlusCtr.listInvestmentPlus != null) {
							for (var i = 0; i < investPlusCtr.listInvestmentPlus.length; i++) {
								investPlusCtr.listInvestmentPlus[i].percent = null;
								investPlusCtr.listInvestmentPlus[i].value = null;
							}
							investPlusCtr.invest.totalPercent = null;
							investPlusCtr.invest.totalValue = null;
						}
						if (investPlusCtr.invest.policy.contractCode == 'VR1'
							|| investPlusCtr.invest.policy.contractCode == 'VS1') {

							if (investPlusCtr.invest.policy.contractCode == 'VR1'
								&& parseFloat(investPlusCtr.invest.investmentValue) > parseFloat(investPlusCtr.invest.instalmentPremium)) {
								self
									.addAlert(
										'Phí đầu tư thêm vượt quá qui định.',
										'warning');
								self.invalidInvestmentValue = true;
								return;
							} else if (investPlusCtr.invest.policy.contractCode == 'VS1'
								&& parseFloat(investPlusCtr.invest.investmentValue) > (parseFloat(investPlusCtr.invest.instalmentPremium) / 2)) {
								self
									.addAlert(
										'Phí đầu tư thêm vượt quá qui định.',
										'warning');
								self.invalidInvestmentValue = true;
								return;
							} else if (parseInt(investPlusCtr.invest.investmentValue) < parseInt(investPlusCtr.invest.minTopup)) {
								self
									.addAlert(
										'Phí đầu tư thêm không đạt phí tối thiểu',
										'warning');
								self.investPlusForm.investmentValue
									.$setValidity('required', false);
								self.invalidInvestmentValue = true;
								return;
							}
							investPlusCtr.listInvestmentPlus[0].percent = 100;
							investPlusCtr.invest.totalPercent = 100;
							investPlusCtr.invest.totalValue = investPlusCtr.invest.investmentValue;
							investPlusCtr.listInvestmentPlus[0].value = investPlusCtr.invest.investmentValue;
						} else if (parseFloat(investPlusCtr.invest.investmentValue) > parseFloat(investPlusCtr.invest.maxTopup * investPlusCtr.invest.api)) {
							self
								.addAlert(
									'Phí đầu tư thêm vượt quá qui định.',
									'warning');
							self.investPlusForm.investmentValue
								.$setValidity('required', false);
							self.invalidInvestmentValue = true;
							return;

						} else if (parseInt(investPlusCtr.invest.investmentValue) < parseInt(investPlusCtr.invest.minTopup)) {
							self
								.addAlert(
									'Phí đầu tư thêm không đạt phí tối thiểu',
									'warning');
							self.investPlusForm.investmentValue
								.$setValidity('required', false);
							self.invalidInvestmentValue = true;
							return;
						} else {
							self.investPlusForm.investmentValue
								.$setValidity('required', true);
							self.invalidInvestmentValue = false;
							if (!self.isDisable) {
								investPlusCtr.changePercent();
								investPlusCtr.changeValue();
							}
						}
						// }
					}
				});
		$scope
			.$watch(
				'investPlusCtr.invest.investmentType',
				function () {
					if (investPlusCtr.listInvestmentPlus != null) {
						for (var i = 0; i < investPlusCtr.listInvestmentPlus.length; i++) {
							investPlusCtr.listInvestmentPlus[i].percent = null;
							investPlusCtr.listInvestmentPlus[i].value = null;
						}
						investPlusCtr.invest.totalPercent = null;
						investPlusCtr.invest.totalValue = null;
					}
				});

		investPlusCtr.changeTransferType = function () {
			if (investPlusCtr.invest.transferType != 'CASH') {
				investPlusCtr.invest.checkAgent = true;
				investPlusCtr.invest.receiptDueDate = investPlusCtr.invest.policy.paidToDate;
				CommonService.query({
					masterurl: 'get-bank-post',
					paymentType: investPlusCtr.invest.transferType
				}, function (result) {
					investPlusCtr.listBank = result;
				});
			} else {
				investPlusCtr.invest.receiptDueDate = investPlusCtr.invest.policy.paidToDate;
				// investPlusCtr.allReceiptDueDates =
				// [investPlusCtr.invest.policy.paidToDate];
				investPlusCtr.invest.checkAgent = false;
				investPlusCtr.invest.receiptDate = new Date();
			}
		};

		self.filterReceiptSubTypeByCode = function (param) {
			return function (item) {
				if (item.receiptTypeCode === param) {
					return true;
				}
				return false;
			};
		};

		investPlusCtr.changeVeKhoan = function () {
			// if(investPlusCtr.invest.veKhoan)
			if (self.PDK == investPlusCtr.invest.receiptTypeCode) {
				self.showDescription = true;
			} else {
				self.showDescription = false;
			}
			// self.addAlert(investPlusCtr.invest.veKhoan, 'warning');
		};

		function caculatorReceiptAmount() {
			if (investPlusCtr.invest.transferType == 'CASH') {
				if (investPlusCtr.invest.policy.receiptDeductAmount === undefined
					|| investPlusCtr.invest.policy.receiptDeductAmount === '')
					investPlusCtr.invest.policy.receiptDeductAmount = 0;

				if (investPlusCtr.invest.policy.premiumAmount === undefined
					|| investPlusCtr.invest.policy.premiumAmount === '')
					investPlusCtr.invest.policy.premiumAmount = 0;

				if (investPlusCtr.invest.receiptTypeCode == self.PDK) {

					var currentDate = new Date();
					currentDate.setHours(0, 0, 0, 0);

					// var paidToDateAdvance =
					// moment(investPlusCtr.invest.policy.paidToDateAdvance,"DD/MM/YYYY");
					var paidToDateAdvance = new Date(
						investPlusCtr.invest.policy.paidToDateAdvance);
					paidToDateAdvance.setHours(0, 0, 0, 0);
					if (!investPlusCtr.invest.policy.policyIPLorULP) {
						investPlusCtr.invest.policy.receiptDeductAmount = 0;
						if (currentDate.getTime() <= paidToDateAdvance
							.getTime()) {
							if (parseFloat(investPlusCtr.invest.policy.premiumAmount) >= 330600) {
								investPlusCtr.invest.policy.receiptDeductAmount = 5000;
							}
						} else {
							var paidToDateAdvanceConvert = new Date(
								investPlusCtr.invest.policy.paidToDateAdvance);
							paidToDateAdvanceConvert.setHours(0, 0, 0, 0);
							var d1 = moment(investPlusCtr.invest.policy.paidToDateAdvance);
							var d2 = moment(currentDate);
							var days = moment.duration(d2.diff(d1)).asDays();
							if (parseInt(days) == 1 || parseInt(days) == 0) {
								if ((paidToDateAdvanceConvert.getDay() === 6 || paidToDateAdvanceConvert
										.getDay() === 0)
									&& (currentDate.getDay() === 0 || currentDate
										.getDay() === 1)) {
									if (parseFloat(investPlusCtr.invest.policy.premiumAmount) >= 330600) {
										investPlusCtr.invest.policy.receiptDeductAmount = 5000;
									}
								}
							}
						}
					}
					// self.receipt.receiptTotalAmount =
					// self.receipt.receiptAgAmount =
					// parseFloat(investPlusCtr.invest.policy.premiumAmount) -
					// parseFloat(investPlusCtr.invest.policy.receiptDeductAmount);
				} else if (investPlusCtr.invest.receiptTypeCode == self.PG) {
					// self.receipt.receiptTotalAmount =
					// self.receipt.receiptAgAmount =
					// caculatorReceiptAmountByReceiptTypeIsPG();
				}
			} else {
				investPlusCtr.invest.policy.receiptDeductAmount = 0;

				if (investPlusCtr.invest.policy.premiumAmount === undefined
					|| investPlusCtr.invest.policy.premiumAmount === '')
					investPlusCtr.invest.policy.premiumAmount = 0;

				if (investPlusCtr.invest.receiptTypeCode == self.PDK) {
					// self.receipt.receiptTotalAmount =
					// self.receipt.bankReceiptBrAmount =
					// parseFloat(investPlusCtr.invest.policy.premiumAmount);
				} else if (investPlusCtr.invest.receiptTypeCode == self.PG) {
					// self.receipt.receiptTotalAmount =
					// self.receipt.bankReceiptBrAmount =
					// caculatorReceiptAmountByReceiptTypeIsPG();
				}
			}
		}
		;

		self.filterPaymentType = function () {
			return function (item) {
				if (item.paymentTypeCode !== 'OTHER') {
					return true;
				}
				return false;
			};
		};

		investPlusCtr.checkChangeAddress = function () {
			if (investPlusCtr.invest.checkChangeAddress) {
				if (investPlusCtr.invest.country != null) {
					investPlusCtr.getProvince();
				}
				if (investPlusCtr.invest.district != null
					&& investPlusCtr.invest.country != null) {
					investPlusCtr.getDistrict(investPlusCtr.invest.country);
				}
				if (investPlusCtr.invest.ward != null
					&& investPlusCtr.invest.district != null) {
					investPlusCtr.getWard(investPlusCtr.invest.district);
				}
			}
		};

		investPlusCtr.findAllPVConfigCancel = function () {
			InvestPlusService.getList({
				uri: 'find-all-pv-config-cancel'
			}, function (result) {
				self.loading = false;
				self.listReasonCancel = result;
			}, function (error) {
				self.loading = false;
			});
		};

		investPlusCtr.openPopupCancelReason = function () {
			investPlusCtr.animationsEnabled = true;
			var modalInstance =
				// show dialog
				$uibModal
					.open({
						animation: investPlusCtr.animationsEnabled,
						templateUrl: GLOBAL_URL
							+ 'partial?uri=ga/investment-plus/layouts/investment-plus-cancel-reason-dialog',
						controller: 'InvestmentCancelReasonDialogController as cancelReasonDlgCtr',
						size: 'lg',
						resolve: {
							lstPaymentCancelReason: function () {
								return self.listReasonCancel;// tranfer data
								// for dialog
							}
						}
					});
			modalInstance.result.then(function (result) {
				// self.addAlert(result, 'success');
				investPlusCtr.cancelInvestment(result);
			}, function (error) {
				investPlusCtr.checkPrint = false;
				investPlusCtr.checkAuthorize = false;
				investPlusCtr.checkCancel = false;
			});
		};

		investPlusCtr.removeFile = function () {
			investPlusCtr.files.splice(0, 1);
		};

		investPlusCtr.removeFilePersonal = function () {
			investPlusCtr.filesPersonal.splice(0, 1);
		};

		investPlusCtr.reset = function () {
			// https://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state#methods_reload
			self.isDisable = false;
			self.firstLoad = 1;
			self.clearMessage();
			$state.transitionTo($state.current, {}, {
				reload: true,
				inherit: false,
				notify: true
			});
		};

		investPlusCtr.getRelationship = function () {
			InvestPlusService.getList({
				uri: 'getRelationShip',
				poId: investPlusCtr.invest.policy.ownerIdNum
			}, function (result) {
				investPlusCtr.listRelationship = result;
			})
		};

		investPlusCtr.checkDifferentPO = function () {
			if (investPlusCtr.invest.differentPO) {
				self.checkIsThirdParty = true;
				investPlusCtr.invest.thirdPartyInfo = {};
				investPlusCtr.lstThirdParty = CommonService.query({
					masterurl: 'thirdParty'
				});
				investPlusCtr.invest.thirdPartyInfo.natlty = 'VN';
				investPlusCtr.invest.thirdPartyInfo.ctrycode = 'VN';
			} else {
				self.checkIsThirdParty = false;
				self.msgThirdPartyInFiserv = '';
				investPlusCtr.invest.thirdPartyInfo = null;
			}
		};

		investPlusCtr.changeThirdParty = function () {
			investPlusCtr.invest.group = '';
			for (var i = 0; i < investPlusCtr.lstThirdParty.length; i++) {
				if (investPlusCtr.lstThirdParty[i].code == investPlusCtr.invest.thirdPartyInfo.relationShip) {
					investPlusCtr.invest.group = investPlusCtr.lstThirdParty[i].shortDesc;
					break;
				}
			}
			if (investPlusCtr.invest.group === 'Related third party') {
				investPlusCtr.isThirdParty = true;
			} else {
				investPlusCtr.isThirdParty = false;
			}
		};

		investPlusCtr.checkThirdParty = function () {
			if (investPlusCtr.invest.thirdPartyInfo.birthdayDate != undefined
				&& investPlusCtr.invest.thirdPartyInfo.surName != undefined
				&& investPlusCtr.invest.thirdPartyInfo.givName != undefined) {
				var hasErr = false;
				if(investPlusCtr.thirdPartyStatus ===  self.HIT && (investPlusCtr.filesPersonal == undefined
					|| investPlusCtr.filesPersonal == null || investPlusCtr.filesPersonal.length < 1)){
					self.addAlert('Vui lòng đính kèm Chứng từ nhân thân.','danger');
					hasErr = true;
				}
				if(hasErr){
					return;
				}
				self.loading = true;
				investPlusCtr.invest.thirdPartyInfo.surName = investPlusCtr.invest.thirdPartyInfo.surName.toUpperCase();
				investPlusCtr.invest.thirdPartyInfo.givName = investPlusCtr.invest.thirdPartyInfo.givName.toUpperCase();
				InvestPlusService.checkThirdPartyFiserv({uri: 'check-third-party-in-fiserv'}, investPlusCtr.invest, function (result) {
						self.checkIsThirdParty = true;
						self.loading = false;
						investPlusCtr.invest.uniqueIdentifier = (result != null && result.uniqueIdentifier != null) ? result.uniqueIdentifier : investPlusCtr.invest.uniqueIdentifier;
						investPlusCtr.invest.thirdPartyStatus = (result != null && result.thirdPartyStatus != null) ? result.thirdPartyStatus : investPlusCtr.invest.thirdPartyStatus;
						if (result != null && result.flgError != 0) {
							investPlusCtr.thirdPartyStatus = result.thirdPartyStatus;
							self.msgThirdPartyInFiserv = 'Đã có lỗi. Vui lòng kiểm tra lại.';
							if(result.messages !=null && result.messages.length > 0) {
								self.msgThirdPartyInFiserv = result.messages[0].message;
							}
							if (result.countCallFiserv > 4) {
								self.msgThirdPartyInFiserv = '';
								investPlusCtr.showDialogConfirmByPass();
							}
							return;
						}
						self.msgThirdPartyInFiserv = '';
						investPlusCtr.thirdPartyStatus ='';
                        investPlusCtr.checkThirdPartyBeforeCallFiserv();
						self.checkIsThirdParty = false;
						return;
					},
					function (error) {
						self.loading = false;
						return;
					});
			}
		};

		investPlusCtr.init = function () {
			if (param.txnId != null) {
				InvestPlusService.get({
					uri: 'get-investment-plus-info',
					// txnId : param.txnId
					txnId: $base64.decode(param.txnId)
				}, function (result) {
					self.loading = false;
					investPlusCtr.validPolicy = true;
					self.isDisable = true;
				}, function (error) {
					self.loading = false;
				}).$promise
					.then(function (result) {
						investPlusCtr.files = [];
						investPlusCtr.filesPersonal = [];
						investPlusCtr.invest = result;
						if (param.taskId != null) {
							investPlusCtr.invest.taskInstanceId = $base64
								.decode(param.taskId);
						}
						if (investPlusCtr.invest.agentCode != null) {
							investPlusCtr.invest.checkAgent = true;
						}
						if (result.archiveDataId != null) {
							var file = {};
							file.name = result.archiveDataId.dataName;
							file.size = result.archiveDataId.contentType;
							file.type = result.archiveDataId.dataType;
							var obj = {
								'file': file,
								'archiveDataId': result.archiveDataId.archiveDataId
							};
							investPlusCtr.files.push(obj);
						}
						if (result.transaction.officeCode != self.$parent.appCtrl.currentOffice.officeCode) {
							self.isDisable = true;
							self
								.addAlert(
									'Yêu cầu đã tạo tại văn phòng khác, vui lòng kiểm tra lại',
									'danger');
						} else {
							// investPlusCtr.disableAll = false;
						}
						if (investPlusCtr.invest.thirdPartyInfo != null) {
							investPlusCtr.invest.differentPO = true;
							CommonService.query({
								masterurl: 'thirdParty'
							}).$promise.then(function (result) {
								investPlusCtr.lstThirdParty = result;
								for (var i = 0; i < result.length; i++) {
									if (result[i].code == investPlusCtr.invest.thirdPartyInfo.relationShip) {
										investPlusCtr.invest.group = result[i].shortDesc;
										break;
									}
								}
								if (investPlusCtr.invest.group == null || investPlusCtr.invest.group == '') {
									investPlusCtr.invest.group = investPlusCtr.invest.thirdPartyInfo.group;
								}
							});
							investPlusCtr.getNationality();
							// investPlusCtr.changeThirdParty();
							if (investPlusCtr.invest.thirdPartyInfo.archiveDataDTO != null) {
								var file = {};
								file.name = investPlusCtr.invest.thirdPartyInfo.archiveDataDTO.dataName;
								file.size = investPlusCtr.invest.thirdPartyInfo.archiveDataDTO.contentType;
								file.type = investPlusCtr.invest.thirdPartyInfo.archiveDataDTO.dataType;
								var obj = {
									'file': file,
									'archiveDataId': investPlusCtr.invest.thirdPartyInfo.archiveDataDTO.archiveDataId
								};
								investPlusCtr.filesPersonal.push(obj);
							}
						}
						InvestPlusService
							.getList(
								{
									uri: 'get-list-fund',
									contractCode: investPlusCtr.invest.policy.contractCode
								},
								function (result) {
									$scope.loading = false;
									if (investPlusCtr.invest.policy.contractCode == 'VR1'
										|| investPlusCtr.invest.policy.contractCode == 'VS1') {
										investPlusCtr.listFund = $filter(
											'filter')(result,
											'VFD1');
										investPlusCtr.listInvestmentPlus = $filter(
											'filter')(result,
											'VFD1');
										investPlusCtr.isVR1 = true;
										investPlusCtr.listInvestmentPlus[0].percent = 100;
										investPlusCtr.listInvestmentPlus[0].value = investPlusCtr.invest.investmentValue;
									} else {
										if (investPlusCtr.invest.policy.contractCode == 'UR2'
											|| investPlusCtr.invest.policy.contractCode == 'UR4'
											|| investPlusCtr.invest.policy.contractCode == 'UR5') {
											investPlusCtr.listFund = $filter(
												'filter')(result,
												'1');
											investPlusCtr.listInvestmentPlus = $filter(
												'filter')(result,
												'1');
										} else if (investPlusCtr.invest.policy.contractCode == 'UR6') {
											investPlusCtr.listFund = $filter(
												'filter')(result,
												'2');
											investPlusCtr.listInvestmentPlus = $filter(
												'filter')(result,
												'2');
										} else {
											investPlusCtr.listFund = result;
											investPlusCtr.listInvestmentPlus = result;
										}
										investPlusCtr.isVR1 = false;
										investPlusCtr.listInvestmentPlus[0].percent = null;
										investPlusCtr.listInvestmentPlus[0].value = null;
									}
								}).$promise
							.then(function (result) {
								for (var i = 0; i < investPlusCtr.listFund.length; i++) {
									for (var j = 0; j < investPlusCtr.invest.listInvestmentPlus.length; j++) {
										if (investPlusCtr.listFund[i].code == investPlusCtr.invest.listInvestmentPlus[j].investmentCode) {
											investPlusCtr.listInvestmentPlus[i].percent = investPlusCtr.invest.listInvestmentPlus[j].percent;
											investPlusCtr.listInvestmentPlus[i].value = investPlusCtr.invest.listInvestmentPlus[j].value;
										}
									}
								}
								if (investPlusCtr.invest.investmentType == 'PERCENT') {
									investPlusCtr.invest.totalPercent = 100;
								} else {
									investPlusCtr.invest.totalPercent = null;
								}
								investPlusCtr.invest.totalValue = investPlusCtr.invest.investmentValue;
								if (investPlusCtr.invest.checkChangeAddress) {
									if (investPlusCtr.invest.country != null) {
										investPlusCtr.getProvince();
									}
									if (investPlusCtr.invest.district != null
										&& investPlusCtr.invest.country != null) {
										investPlusCtr
											.getDistrict(investPlusCtr.invest.country);
									}
									if (investPlusCtr.invest.ward != null
										&& investPlusCtr.invest.district != null) {
										investPlusCtr
											.getWard(investPlusCtr.invest.district);
									}
								}
								CommonService.query({
									masterurl: 'receipt-types'
								}, function (result) {
									investPlusCtr.listVeKhoan = result;
									// investPlusCtr.invest.receiptTypeCode
									// = "4";
								});
								CommonService.query({
									masterurl: 'receipt-subtypes'
								}, function (result) {
									investPlusCtr.listDesc = result;
									// investPlusCtr.invest.receiptDescription
									// = "3";
								});
								investPlusCtr.findAllPVConfigCancel();
								if (investPlusCtr.invest.policy.contractCode == 'UR2'
									|| investPlusCtr.invest.policy.contractCode == 'UR4') {
									self.oneDoor = true;
								} else if (investPlusCtr.invest.policy.contractCode == 'UR5'
									|| investPlusCtr.invest.policy.contractCode == 'UR6') {

									if (investPlusCtr.invest.greaterThan21 > 21) {
										self.oneDoor = true;
									}
								} else if (investPlusCtr.invest.policy.contractCode != 'UR2'
									&& investPlusCtr.invest.policy.contractCode != 'UR4'
									&& investPlusCtr.invest.policy.contractCode != 'UR5'
									&& investPlusCtr.invest.policy.contractCode != 'UR6') {
									self.oneDoor = true;
								}
								investPlusCtr.invest.mobileCode = '84';
								investPlusCtr.invest.homePhoneCode = '84';
							});
					});
			}
		};

		investPlusCtr.findAllPVConfigCancel = function () {
			InvestPlusService.getList({
				uri: 'find-all-pv-config-cancel'
			}, function (result) {
				self.loading = false;
				self.listReasonCancel = result;
			}, function (error) {
				self.loading = false;
			});
		};

		investPlusCtr.cancelInvestment = function (cancelId) {
			investPlusCtr.invest.reasonCancel = cancelId;
			InvestPlusService.post({
				uri: 'cancel-investment-plus'
			}, investPlusCtr.invest, function (result) {
				self.loading = false;
				// investPlusCtr.checkAllDisable = true;
				// investPlusCtr.invest = result;
				investPlusCtr.reset();
			}, function (error) {
				self.loading = false;
			});
		};

		investPlusCtr.sendToCS = function () {
			InvestPlusService.post({
				uri: 'send-to-cs',
				taskId: $base64.decode(param.taskId),
				txnId: $base64.decode(param.txnId)
			}, investPlusCtr.invest, function (result) {
				self.loading = false;
				investPlusCtr.init();
				// investPlusCtr.invest = result;
				self.isDisable = true;
			}, function (error) {
				self.loading = false;
			});
		};

		self.checkAmountLT300m = function (totalAmount) {
			if (parseFloat(totalAmount) >= 300000000) {
				self.amountLT300m = false;
			} else {
				self.amountLT300m = true;
			}
		};

		investPlusCtr.release = function () {
			InvestPlusService.post({
				uri: 'release-investment-plus',
				taskId: $base64.decode($stateParams.taskId)
			}, investPlusCtr.invest, function (result) {
				self.loading = false;
				self.isDisable = true;
				self.addAlert('Trả task thành công.', 'success');
			}, function (error) {
				self.loading = false;
			});
		};

		investPlusCtr.calculateYear = function () {
			if (investPlusCtr.invest.thirdPartyInfo.birthdayDate != undefined
				&& investPlusCtr.invest.thirdPartyInfo.birthdayDate != '') {
				var dob2 = $filter('date')(
					investPlusCtr.invest.thirdPartyInfo.birthdayDate,
					'dd/MM/yyyy');
				InvestPlusService.get({
					uri: 'calculate-year-old',
					birthMsDate: dob2
				}, function (result) {
					if (result.age < 15) {
						self.investPlusForm.birthdayDate.$setValidity(
							'minYear', false);
					} else {
						self.investPlusForm.birthdayDate.$setValidity(
							'minYear', true);
					}
				}, function (e) {

				});
			}
		};

		investPlusCtr.doSubmit = function () {
			InvestPlusService.post({
				uri: 'do-submit',
				taskId: $base64.decode(param.taskId),
				txnId: $base64.decode(param.txnId)
			}, investPlusCtr.invest, function (result) {
				self.loading = false;
//				investPlusCtr.invest = result;
				if (result.reasonSendToCS == null || result.reasonSendToCS == '') {
					investPlusCtr.init();
				} else {
					self.oneDoor = false;
					investPlusCtr.invest = result;
				}
			}, function (error) {
				self.loading = false;
				self.oneDoor = false;
			});
		};

		//
		investPlusCtr.checkThirdPartyBeforeCallFiserv = function () {
			if (investPlusCtr.invest.thirdPartyInfo.birthdayDate != undefined
				&& investPlusCtr.invest.thirdPartyInfo.surName != undefined
				&& investPlusCtr.invest.thirdPartyInfo.givName != undefined) {
				var securityNo = '';
				if (investPlusCtr.invest.thirdPartyInfo.securityNo != undefined
					&& investPlusCtr.invest.thirdPartyInfo.securityNo != null) {
					securityNo = investPlusCtr.invest.thirdPartyInfo.securityNo;
				}
				self.loading = true;

				InvestPlusService
					.returnValue(
						{
							uri: 'check-third-party',
							securityNo: securityNo,
							birthDay: $filter('date')
							(
								investPlusCtr.invest.thirdPartyInfo.birthdayDate,
								'dd/MM/yyyy'),
							surName: investPlusCtr.invest.thirdPartyInfo.surName,
							givName: investPlusCtr.invest.thirdPartyInfo.givName
						},
						function (result) {
							self.loading = false;
							self.totalAmountThirdParty = parseFloat(result.response);
							self.totalAmountThirdPartyTemp = self.totalAmountThirdParty
								+ parseFloat(investPlusCtr.invest.totalAmount);

							if (result.response == 0) {
								self
									.addAlert(
										'Khách hàng chưa có giao dịch trong ngày',
										'warning');
							} else {
								var message = 'Khách đã có giao dịch trong ngày. Số tiền 3rd party đã nộp đến thời điểm hiện tại là '
									+ self.totalAmountThirdPartyTemp;

								if (self.totalAmountThirdPartyTemp >= '300000000') {
									if (investPlusCtr.invest.thirdPartyInfo != null && investPlusCtr.filesPersonal.length == 0) {
										message = message + '. Vui lòng attach CMND / CCCD / Passport của người nộp tiền trước khi gửi duyệt';
									}
									self.amountLT300m = false;
								} else {
									self.amountLT300m = true;
								}

								self.addAlert(message, 'warning');
							}

							self.clickCheckThirdParty = false;
						}, function (error) {
							self.loading = false;
						});

				self.loading = false;
			}
		}

		investPlusCtr.changeTextThirdParty = function(){
			self.checkIsThirdParty = true;
		}

		investPlusCtr.showDialogConfirmByPass = function () {
			investPlusCtr.animationsEnabled = true;
			var modalInstance =
				// show dialog
				$uibModal
					.open({
						animation: investPlusCtr.animationsEnabled,
						templateUrl: GLOBAL_URL
							+ 'partial?uri=ga/investment-plus/layouts/confirm-fiserv-status-dialog',
						controller: 'ConfirmFiservStatusDialogController as confirmFiservStatusDlgCtr',
						size: 'sm'
					});
			modalInstance.result.then(function (result) {
				// get id assigner and update db
				investPlusCtr.invest.byPass = 'GA';
				investPlusCtr.invest.status = result.toUpperCase();
				investPlusCtr.checkThirdParty();
				if(!self.checkIsThirdParty){
					return;
				}
				investPlusCtr.checkThirdPartyBeforeCallFiserv();
			}, function (error) {
			});
		};
	}
})();
